import { render } from "./HeaderUnidade.vue?vue&type=template&id=301fd454"
import script from "./HeaderUnidade.vue?vue&type=script&lang=js"
export * from "./HeaderUnidade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__